import { History } from 'history'
import * as React from 'react'
import ServiceCreateBottomBar from '../../../containers/services/ServiceCreateBottomBar'
import ServiceCreateHeader from '../../../containers/services/ServiceCreateHeader'
import ServiceDays from '../../../containers/services/ServiceDays'
import ServiceEditMainInfo from '../../../containers/services/ServiceEditMainInfo'
import ServicePricingBreakdown from '../../../containers/services/ServicePricingBreakdown'
import ServiceProviders from '../../../containers/services/ServiceProviders'
import ServiceProducts from '../../../containers/services/ServiceProducts'
import StepsIndicator from '../../../containers/services/StepsIndicator'
import { IServiceEditStep, IServiceEditStepData } from '../../../types/index'
import EntityErrorMessage from '../../ui/entity/EntityErrorMessage'
import ServiceEditZones from './ServiceEditZones'
import { RouteComponentProps } from 'react-router-dom'
import { IMap, IZoneObject } from '../../../types/index'

interface IServiceCreatePaneProps extends RouteComponentProps {
  step: IServiceEditStep
  updatingError: string
  fetchingError: string
  stepData: IServiceEditStepData
  onComponentMount: () => void
  onStepCompleted: (position: number) => void
  onHideErrorClick: () => void
  history: History
  zones: IMap<IZoneObject>
}

interface IServiceCreatePaneState {
  currentError: { isError: boolean; message: string }
}

class ServiceCreatePane extends React.Component<IServiceCreatePaneProps, IServiceCreatePaneState> {
  private mainInfoFormRef: any

  private pricingBreakdownFormRef: any

  private serviceProductsFormRef: any

  private serviceDaysFormRef: any

  private serviceZonesFormRef: any

  private stepStrategy: Array<{
    filter: (stepName: string) => boolean
    render: () => void
    submit: () => void
  }> = [
    {
      filter: (stepName: string) => stepName === 'mainInfo',
      render: () => {
        return (
          <ServiceEditMainInfo
            formRef={this.formRefCallback}
            onStepSuccessfullyCompleted={this.createStepCompleteCallback(0)}
          />
        )
      },
      submit: () => this.mainInfoFormRef.submitForm()
    },
    {
      filter: (stepName: string) => stepName === 'products',
      render: () => {
        return (
          <ServiceProducts
            formRef={this.serviceProductsFormRefCallback}
            onStepSuccessfullyCompleted={this.createStepCompleteCallback(1)}
          />
        )
      },
      submit: () => this.serviceProductsFormRef.click()
    },
    {
      filter: (stepName: string) => stepName === 'serviceDays',
      render: () => {
        return (
          <ServiceDays
            formRef={this.serviceDaysFormRefCallback}
            onStepSuccessfullyCompleted={this.createStepCompleteCallback(2)}
          />
        )
      },
      submit: () => this.serviceDaysFormRef.click()
    },
    {
      filter: (stepName: string) => stepName === 'goinZones',
      render: () => {
        return (
          <ServiceEditZones
            history={this.props.history}
            location={this.props.location}
            match={this.props.match}
            formRef={this.serviceZonesFormRefCallback}
            onStepSuccessfullyCompleted={this.createStepCompleteCallback(3)}
            zones={this.props.zones}
          />
        )
      },
      submit: () => this.serviceZonesFormRef.click()
    },
    {
      filter: (stepName: string) => stepName === 'pricingBreakdown',
      render: () => {
        return (
          <ServicePricingBreakdown
            formRef={this.pricingFormRefCallback}
            onCreateServiceCompleted={this.handleCreateServiceCompleted}
          />
        )
      },
      submit: () => this.pricingBreakdownFormRef.submitForm()
    }
  ]

  constructor(props: IServiceCreatePaneProps) {
    super(props)
    this.state = {
      currentError: { isError: false, message: '' }
    }
  }

  public componentDidMount() {
    this.props.onComponentMount()
  }

  public render() {
    const stepStrategyItem = this.props.step ? this.stepStrategy.find(it => it.filter(this.props.step.name)) : null

    return (
      <div>
        {this.errorText() && (
          <EntityErrorMessage onCloseBtnClick={this.handleHideErrorClick}>{this.errorText()}</EntityErrorMessage>
        )}

        <ServiceCreateHeader currentError={this.state.currentError} />

        <StepsIndicator />

        {stepStrategyItem && stepStrategyItem.render()}
        {/* Hijacking this pane to show geozones for testing porpuses. until this part is done */}
        {/*<ServiceCreateGoinZones showMessage={this.showMessage} history={this.props.history} match={this.props.match}/>*/}
        <div className='absolute bottom-0 col-12'>
          <ServiceCreateBottomBar onNextClick={this.handleNextClick} />
        </div>
      </div>
    )
  }

  private showMessage = (message: string, isError: boolean) => {
    if (this.state.currentError.message === message) {
      return
    }
    this.setState({ currentError: { message, isError } })
  }

  private errorText = () => {
    if (this.props.stepData.updatingError) {
      return this.props.stepData.updatingError
    }
    if (this.props.stepData.fetchingError) {
      return this.props.stepData.fetchingError
    }
    return ''
  }

  private handleHideErrorClick = () => {
    this.props.onHideErrorClick()
  }

  private createStepCompleteCallback = (step: number) => () => {
    return this.props.onStepCompleted(step)
  }

  private formRefCallback = (node: any) => {
    this.mainInfoFormRef = node
  }

  private pricingFormRefCallback = (node: any) => {
    this.pricingBreakdownFormRef = node
  }

  private serviceProductsFormRefCallback = (node: any) => {
    this.serviceProductsFormRef = node
  }

  private serviceDaysFormRefCallback = (node: any) => {
    this.serviceDaysFormRef = node
  }

  private serviceZonesFormRefCallback = (node: any) => {
    this.serviceZonesFormRef = node
  }

  private handleCreateServiceCompleted = () => {
    // To show status 'Service successfully created'
    setTimeout(() => {
      this.props.history.push('/services')
    }, 1000)
  }

  private handleNextClick = () => {
    const stepStrategyItem = this.stepStrategy.find(it => it.filter(this.props.step.name))
    if (stepStrategyItem) {
      stepStrategyItem.submit()
    }
  }
}

export default ServiceCreatePane



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceCreatePane.tsx